import { Pipe, PipeTransform } from "@angular/core";
import { TerritoryFrequencyColorsEnum, TerritoryFrequencyEnum, TerritoryRouteTypeColorsEnum, TerritoryRouteTypeEnum } from "../utilities/enums/TerritoriesEnum";

@Pipe({
    name: 'routeFrecuencyColor'
})
export class RouteFrecuencyColorPipe implements PipeTransform {
    transform(routeFrecuency: string) {
        const frecuencyColor = TerritoryFrequencyColorsEnum;
        const routeFrecuencyEnum = TerritoryFrequencyEnum;
        
        //busca el reouteColor usando la la key de routeFrecuency, si no encunetra el valor, intenta usar el key
        const routeTypeValues = Object.values(routeFrecuencyEnum);
        const index = routeTypeValues.indexOf(routeFrecuency as TerritoryFrequencyEnum);
        if (index !== -1) {
            const key = Object.keys(routeFrecuencyEnum)[index];
            return frecuencyColor[key];
        }else{
            const routeTypeKeys = Object.keys(routeFrecuencyEnum);
            routeTypeKeys.forEach(key => {
                key.replace(/_/g, ' ');           
            });
            const index = routeTypeKeys.indexOf(routeFrecuency as TerritoryFrequencyEnum);
            if (index !== -1) {
                const key = Object.keys(routeFrecuencyEnum)[index];
                return frecuencyColor[key];
            }
        }
        return null;
    }
}